export class RemittanceStatisticsModel {
    public RemittanceId: number;
    public TotalAmount: number;
}